import { motion } from "framer-motion";
import { Zap, Eye, Settings, Building2 } from "lucide-react";

const differentiators = [
  { icon: Zap, title: "Instant lead response systems", description: "Every lead gets contacted within seconds, not hours." },
  { icon: Eye, title: "Full-funnel visibility", description: "See every step from click to customer—not just lead counts." },
  { icon: Settings, title: "Automation-first approach", description: "We automate repetitive tasks so your team focuses on closing." },
  { icon: Building2, title: "Built for service businesses", description: "Designed for high-value customers who book appointments." },
];

export const DifferentiatorSection = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            What Makes Us Different
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            We don't just run ads. We build the entire system that turns clicks into customers.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6">
          {differentiators.map((item, i) => (
            <motion.div
              key={i}
              className="p-6 rounded-xl border border-border bg-card hover:shadow-lg transition-shadow"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <item.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">{item.title}</h3>
              <p className="text-muted-foreground text-sm">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
